import { render } from "./AddToBagTile.vue?vue&type=template&id=6a9478a2&scoped=true"
import script from "./AddToBagTile.vue?vue&type=script&lang=js"
export * from "./AddToBagTile.vue?vue&type=script&lang=js"

import "./AddToBagTile.vue?vue&type=style&index=0&id=6a9478a2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9478a2"]])

export default __exports__